import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const ArmorySchemas = {
    ArmoryShifts: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        status: zod.string().optional(),
        beginIn: zod.coerce.number().optional(),
        endIn: zod.coerce.number().optional(),
    }),
    ArmoryShiftForm: zod.object({
        id: zod.coerce.number().optional(),
    }),
    MyArmoryShifts: zod.object({}),
};
